<template>
  <label
    :class="[
      'v-checkbox',
      small ? 'small' : '',
	  checked ? 'checked' : 'unchecked',
	  red ? 'red' : ''
    ]"
    @mouseenter="inputFocus"
    @mouseleave="inputBlur"
  >
    <input
      type="checkbox"
      :name="name"
      :checked="value"
      @input="handleInput($event.target.checked)"
    >
    <span class="tx-gray-700" :class="classLabel">{{ label }}</span>

    <div
      v-if="hint.length > 0"
      :class="[
        'hint',
        hintActive ? 'active' : ''
      ]"
    >
      {{ hint }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'VCheckbox',
  props: {
    name: {
      type: String,
      required: true,
      default: 'input',
    },
    label: {
      type: String,
      required: true,
      default: 'input',
    },
    red: {
      type: Boolean,
      default: false,
    },
    value: {},
    values: {
      type: Object,
      default: () => ({
        checked: true,
        unchecked: false,
      }),
    },
    hint: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
	classLabel: {
		type: String,
		default: 'tx-16',
	},
  },
  data() {
    return {
      checked: false,
      hintActive: false,
      emitter: false,
    };
  },
  mounted() {
    this.handleInput(this.value);
    this.$nextTick(function () {
      this.emitter = true;
    });
  },
  watch: {
    value() {
      this.handleInput(this.value);
    },
  },
  methods: {
    handleInput(value) {
      if (value === true) {
        this.checked = true;
        this.$emit('input', this.values.checked);
        if (this.emitter) {
          this.$emit('blur', this.values.checked);
        }
      } else {
        this.checked = false;
        this.$emit('input', this.values.unchecked);
        if (this.emitter) {
          this.$emit('blur', this.values.unchecked);
        }
      }
    },
    inputFocus() {
      this.hintActive = true;
    },
    inputBlur() {
      this.hintActive = false;
    },
  },
};
</script>

<style>
  .v-checkbox {
	gap: 10px;
	height: 40px;
	cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 15px;
    border: 1px solid #e2e2e2;
    background: white;
    border-radius: 7px;
    transition: all .2s ease-in-out 0s;
    position: relative;
  }

  .v-checkbox.small {
    height: 25px;
    padding: 0 10px;
    gap: 10px;
    font-family: inherit;
    font-size: inherit;
  }

  .v-checkbox input {
    appearance: none;
    --webkit-appearance: none;
    --moz-appearance: none;
	cursor: pointer;

    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #6a6a6a;

    transition: all .2s ease-in-out 0s;
  }

  .v-checkbox input:focus {
	background-color: white;
  }

  .v-checkbox.small input {
    width: 15px;
    height: 15px;
    flex: 0 0 15px;
  }

  .v-checkbox.checked {
	background: #e8f5e9;
    border: 1px solid #4CAF50 !important;
  }

  .v-checkbox.checked input {
    border: 5px solid #4CAF50 !important;
  }	


  .v-checkbox.red.checked {
	background: #f7d1d5;
    border: 1px solid #dc3545 !important;
  }

  .v-checkbox.red.checked input {
    border: 5px solid #dc3545 !important;
  }	

  .v-checkbox.unchecked {
    background: #F8F9FA;
    border: 1px solid #ced4da !important;
  }

  .v-checkbox.unchecked input {
    border: 2px solid #ced4da !important;
  }

  .v-checkbox .hint {
    transform: translate3d(0, -30px, 0);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: all .2s ease-in-out 0s;
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    right: 0;
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    z-index: 99;
    border: 1px solid #e2e2e2;
  }

  .v-checkbox .hint.active {
    transform: translate3d(0, 0, 0);
    opacity: 1;
    visibility: visible;
  }
</style>
